import compareDesc from 'date-fns/compare_desc'
import { combineReducers } from 'redux'

// ACTIONS
export const FETCH = 'offerzen/workHistories/FETCH'
export const FETCH_SUCCESS = 'offerzen/workHistories/FETCH_SUCCESS'

export const DELETE = 'offerzen/workHistories/DELETE'
export const DELETE_SUCCESS = 'offerzen/workHistories/DELETE_SUCCESS'

export const CREATE = 'offerzen/workHistories/CREATE'
export const CREATE_SUCCESS = 'offerzen/workHistories/CREATE_SUCCESS'

export const UPDATE = 'offerzen/workHistories/UPDATE'
export const UPDATE_SUCCESS = 'offerzen/workHistories/UPDATE_SUCCESS'

export const ADD_TEMP_ITEM = 'offerzen/workHistories/ADD_TEMP_ITEM'
export const DELETE_TEMP_ITEM = 'offerzen/workHistories/DELETE_TEMP_ITEM'

export const SET_WORK_HISTORY_TO_DELETE = 'offerzen/workHistories/SET_WORK_HISTORY_TO_DELETE'

export const SEARCH_SKILLS = 'offerzen/workHistories/SEARCH_SKILLS'
export const SEARCH_SKILLS_SUCCESS = 'offerzen/workHistories/SEARCH_SKILLS_SUCCESS'
export const SEARCH_SKILLS_ERROR = 'offerzen/workHistories/SEARCH_SKILLS_ERROR'

export const SEARCH_COMPANIES = 'offerzen/workHistories/SEARCH_COMPANIES'
export const SEARCH_COMPANIES_SUCCESS = 'offerzen/workHistories/SEARCH_COMPANIES_SUCCESS'
export const SEARCH_COMPANIES_ERROR = 'offerzen/workHistories/SEARCH_COMPANIES_ERROR'

export const SEARCH_ROLES = 'offerzen/workHistories/SEARCH_ROLES'
export const SEARCH_ROLES_SUCCESS = 'offerzen/workHistories/SEARCH_ROLES_SUCCESS'
export const SEARCH_ROLES_ERROR = 'offerzen/workHistories/SEARCH_ROLES_ERROR'

// FETCH CREATORS
export const fetchWorkHistory = id => ({
  type: FETCH,
  payload: {
    id,
  },
})

export const fetchWorkHistorySuccess = data => ({
  type: FETCH_SUCCESS,
  payload: [...data],
})

export const createWorkHistory = (profileId, data, resolve, reject) => ({
  type: CREATE,
  meta: { resolve, reject },
  payload: {
    loading: true,
    profileId,
    data,
  },
})

export const createWorkHistorySuccess = data => ({
  type: CREATE_SUCCESS,
  payload: { ...data },
})

export const deleteWorkHistory = (id, candidate_id) => ({
  type: DELETE,
  payload: { id, candidate_id },
})

export const deleteWorkHistorySuccess = id => ({
  type: DELETE_SUCCESS,
  payload: { id },
})

export const updateWorkHistory = (data, candidate_id, resolve, reject) => ({
  type: UPDATE,
  meta: { resolve, reject },
  payload: {
    ...data,
    candidate_id,
    loading: true,
  },
})

export const updateWorkHistorySuccess = data => ({
  type: UPDATE_SUCCESS,
  payload: {
    ...data,
    loading: false,
  },
})

/*
 ** `tempId` is used as a unique identifier for new instances of WorkHistoryItemForm,
 ** only records that have not been persisted to the database will use `tempId`, those
 ** that have will use an `id` instead
 */
export const addBlankWorkHistoryItem = tempId => ({
  type: ADD_TEMP_ITEM,
  payload: {
    tempId,
    isNew: true,
  },
})

export const deleteBlankWorkHistoryItem = tempId => ({
  type: DELETE_TEMP_ITEM,
  payload: { tempId },
})

export const setWorkHistoryItemToDelete = workHistoryItemToDelete => ({
  type: SET_WORK_HISTORY_TO_DELETE,
  payload: { workHistoryItemToDelete },
})

export const searchSkills = (id, term) => ({
  type: SEARCH_SKILLS,
  meta: { id, term },
  payload: {
    searchingSkills: true,
    searchSkillsError: null,
    id,
  },
})

export const searchSkillsSuccess = (id, data) => ({
  type: SEARCH_SKILLS_SUCCESS,
  payload: {
    searchingSkills: false,
    skillsSearchResults: data,
    id,
  },
})

export const searchSkillsError = errorMessage => ({
  type: SEARCH_SKILLS_ERROR,
  error: true,
  payload: new Error(errorMessage),
})

export const searchCompanies = (id, term) => ({
  type: SEARCH_COMPANIES,
  meta: { term },
  payload: {
    searchingCompanies: true,
    searchCompaniesError: null,
    id,
  },
})

export const searchCompaniesSuccess = (id, data) => ({
  type: SEARCH_COMPANIES_SUCCESS,
  payload: {
    searchingCompanies: false,
    companiesSearchResults: data,
    id,
  },
})

export const searchCompaniesError = errorMessage => ({
  type: SEARCH_COMPANIES_ERROR,
  error: true,
  payload: new Error(errorMessage),
})

export const searchRoles = (id, term) => ({
  type: SEARCH_ROLES,
  meta: { term },
  payload: {
    searchingRoles: true,
    searchRolesError: null,
    id,
  },
})

export const searchRolesSuccess = (id, data) => ({
  type: SEARCH_ROLES_SUCCESS,
  payload: {
    searchingRoles: false,
    rolesSearchResults: data,
    id,
  },
})

export const searchRolesError = errorMessage => ({
  type: SEARCH_ROLES_ERROR,
  error: true,
  payload: new Error(errorMessage),
})

// REDUCERS
const initialState = {
  loading: false,
  isNew: false,

  searchingSkills: false,
  searchSkillsError: null,
  skillsSearchResults: [],

  searchingCompanies: false,
  searchCompaniesError: null,
  companiesSearchResults: [],

  searchingRoles: false,
  searchRolesError: null,
  rolesSearchResults: [],
}

const workHistory = (state = initialState, action) => {
  switch (action.type) {
    case ADD_TEMP_ITEM:
      return {
        ...state,
        ...action.payload,
      }

    case CREATE_SUCCESS:
      return {
        ...state,
        ...action.payload,
      }

    case UPDATE:
    case UPDATE_SUCCESS:
      if (state.id !== action.payload.id) return state

      return {
        ...state,
        ...action.payload,
      }

    case SEARCH_SKILLS:
    case SEARCH_COMPANIES:
    case SEARCH_ROLES:
    case SEARCH_SKILLS_SUCCESS:
    case SEARCH_COMPANIES_SUCCESS:
    case SEARCH_ROLES_SUCCESS:
      const itemId = state.id || state.tempId
      if (itemId !== action.payload.id) return state

      const { id, ...payload } = action.payload
      return {
        ...state,
        ...payload,
      }

    case SEARCH_SKILLS_ERROR:
      return {
        ...state,
        searchingSkills: false,
        searchSkillsError: action.payload,
      }

    case SEARCH_COMPANIES_ERROR:
      return {
        ...state,
        searchingCompanies: false,
        searchCompaniesError: action.payload,
      }

    case SEARCH_ROLES_ERROR:
      return {
        ...state,
        searchingRoles: false,
        searchRolesError: action.payload,
      }

    default:
      return {
        ...initialState,
        ...state,
      }
  }
}

const workHistoryItemToDelete = (state = {}, action) => {
  switch (action.type) {
    case SET_WORK_HISTORY_TO_DELETE:
      return {
        ...state,
        ...action.payload.workHistoryItemToDelete,
      }

    default:
      return state
  }
}

const defaultWorkHistory = []

const entities = (state = defaultWorkHistory, action) => {
  switch (action.type) {
    case CREATE_SUCCESS:
    case ADD_TEMP_ITEM:
      return [...state, workHistory(undefined, action)]

    case DELETE_TEMP_ITEM:
      return [...state.filter(history => history.tempId !== action.payload.tempId)]

    case DELETE_SUCCESS:
      return [...state.filter(history => history.id !== action.payload.id)]

    case FETCH_SUCCESS:
      return [...action.payload.map(history => workHistory(history, action)).sort((a, b) => compareDesc(a.start, b.start))]

    case UPDATE:
    case UPDATE_SUCCESS:
    case SEARCH_SKILLS:
    case SEARCH_SKILLS_SUCCESS:
    case SEARCH_SKILLS_ERROR:
    case SEARCH_COMPANIES:
    case SEARCH_COMPANIES_SUCCESS:
    case SEARCH_COMPANIES_ERROR:
    case SEARCH_ROLES:
    case SEARCH_ROLES_SUCCESS:
    case SEARCH_ROLES_ERROR:
      return state.map(history => workHistory(history, action)).sort((a, b) => compareDesc(a.start, b.start))

    default:
      return state
  }
}

const workHistoriesReducer = combineReducers({
  entities,
  workHistoryItemToDelete,
})

export default workHistoriesReducer

export const getWorkHistory = state => state.views.profile.workHistories.entities || defaultWorkHistory
